import { CollectionPaymentTypes, IceGateStatus, TransactionPaymentType } from "@gtpl/shared-models/common-models";
import { PaymentTypeReq } from "./payment-req";

export class iceGateReq{
    scrollNo : string;
    scrollDate : Date|string;
    createdUser : string;
    unitId:number
   recievedAmt : number;
   payment:CollectionPaymentTypes
    buyerId?:number;
    soId?:number;
    invNum?:string;
    poNum?:string
    eta?:Date|string;
    shippingBillNo? : string
    shippingBillDate? : Date|string
    constructor(
    scrollNo : string,
    scrollDate : Date|string,
    createdUser : string,
    unitId:number,
    recievedAmt : number,
    payment:CollectionPaymentTypes,
     buyerId?:number,
     soId?:number,
     invNum?:string,
     poNum?:string,
    eta?:Date|string,
    shippingBillNo? : string,
    shippingBillDate? : Date|string,
    ){
    this.scrollDate = scrollDate
    this.scrollNo=scrollNo
    this.recievedAmt = recievedAmt
    this.buyerId = buyerId
    this.soId = soId
    this.invNum = invNum
    this.createdUser = createdUser
    this.poNum =poNum
    this.payment = payment
    this.eta = eta
    this.unitId = unitId
    this.shippingBillDate = shippingBillDate
    this.shippingBillNo = shippingBillNo
 }
 }
 export class BrcReq{
    brcNo:string
    brcVal: number
    createdUser : string;
    unitId:number
    poNum:string
    brcDate:Date|string
    irmnNo:string
    scrollNo? : string;
    scrollDate? : Date|string;
   recievedAmt? : number;
    buyerId?:number;
    soId?:number;
    invNum?:string;
    eta?:Date|string;
    rodtepCount?:number
    exportCount?:number
    recievablePayment?:TransactionPaymentType

    constructor(
        brcNo:string,
        brcVal: number,
        createdUser : string,
    unitId:number,
        poNum:string,
        brcDate:Date|string,
        irmnNo:string,
        scrollNo? : string,
    scrollDate? : Date|string,
   recievedAmt? : number,
    buyerId?:number,
    soId?:number,
    invNum?:string,
    eta?:Date|string,
    rodtepCount?:number,
    exportCount?:number,
    recievablePayment?:TransactionPaymentType

    ){
    this.brcDate = brcDate
    this.brcNo = brcNo
    this.brcVal = brcVal
    this.poNum = poNum
    this.irmnNo = irmnNo
    this.createdUser = createdUser
    this.invNum = invNum
    this.recievedAmt = recievedAmt
    this.buyerId = buyerId
    this.scrollDate = scrollDate
    this.scrollNo = scrollNo
    this.soId = soId
    this.eta = eta
    this.rodtepCount = rodtepCount
    this.exportCount = exportCount
    this.unitId = unitId
    this.recievablePayment = recievablePayment
 }
 }



 export class RodtepReportReq{
    fromDate?:any
    toDate?:any
    company?:string
    unitId?:number
    constructor(
        fromDate?:any,
        toDate?:any,
        company?:string,
        unitId?:number
    ){
    this.fromDate = fromDate
    this.toDate = toDate
    this.unitId=unitId;
    this.company=company;
    }
}
export class iceGateVerification{
    poNum:string
    invNum:string
    status:IceGateStatus
    soId?:number
    buyerId?:number
    invAmt?:number
    unitId?:number
    constructor(
        poNum:string,
        invNum:string,
        status:IceGateStatus,
        soId?:number,
    buyerId?:number,
    invAmt?:number,
    unitId?:number



    ){
        this.invNum= invNum
        this.poNum = poNum
        this.status = status
        this.soId = soId
        this.buyerId = buyerId
        this.invAmt = invAmt
        this.unitId = unitId
    }
}
export class SaleReceiveReq{
    soId:number
    invoiceNumber:string
    constructor(
        invoiceNumber:string,
    soId:number

    ){
      this.invoiceNumber = invoiceNumber
        this.soId = soId
    }

}
export class DutyDrawBackDateReq{
    fromDate?:any
    toDate?:any

    constructor(fromDate?:any,toDate?:any){
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
    
}

export class DutyDrawBackReportReq{
    fromDate?:any
    toDate?:any
    invoiceNumber?:any
    unitId?:number
    unitName?:string
    supplierName?:string
    vendorName?:string
    constructor(fromDate?:any,toDate?:any,invoiceNumber?:any,unitId?:number,unitName?:string,supplierName?:string,vendorName?:string){
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.invoiceNumber = invoiceNumber;
        this.unitId = unitId
        this.unitName = unitName
        this.supplierName = supplierName
        this.vendorName = vendorName
    }
}